<!-- mainMidMovie -->
<div class="mainMidMovie">
    <iframe src="https://player.vimeo.com/video/895679383?h=15929c1680&amp;muted=1&amp;autoplay=1&amp;loop=1&amp;background=1&amp;app_id=122963" width="426" height="240" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="더조각 홈페이지 메인영상" data-ready="true" class="elementor-background-video-embed"></iframe>
    <dl>
        <dt data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">더조각이 원장님들께 대체 왜 유명하냐구요?<br>매출이 오른 실제 사례가 쏟아져 나오기 때문입니다.</dt>
        <dd data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000">충격받을 만한 이야기가 3분 이면 확인 가능합니다.</dd>
    </dl>
</div>
<!-- //mainMidMovie -->

<!-- mainSystem -->
<div class="mainSystem">
    <div class="contain">
        <div class="mainSysTop">
            <p data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">20년 뷰티시장 현장의 실무 경험 + 1만명 회원의 교육플랫폼의 빅데이터</p>
            <h2 data-aos="fade-down" data-aos-delay="400" data-aos-duration="1000">= 현장의 고민 파악의 대안</h2>
            <h3 data-aos="fade-down" data-aos-delay="600" data-aos-duration="1000">뷰티샵 매출증대 시스템 <span>'더조각 플러스 시스템'</span></h3>
        </div>
        <ul>
            <li data-aos="fade-right" data-aos-delay="600" data-aos-duration="1000">
                <span>1</span>
                <p>경쟁력 있는 차별화된 <i></i>아이템이 없을까?</p>
            </li>
            <li data-aos="fade-right" data-aos-delay="700" data-aos-duration="1000">
                <span>2</span>
                <p>시술자도 소비자도 건강하게 <i></i>예뻐질수는 없을까?</p>
            </li>
            <li data-aos="fade-right" data-aos-delay="800" data-aos-duration="1000">
                <span>3</span>
                <p>우리샵 손님이 원하는 <i></i>추가 아이템?</p>
            </li>
            <li data-aos="fade-right" data-aos-delay="900" data-aos-duration="1000">
                <span>4</span>
                <p>보다 손쉽게 매출을 <i></i>늘리는 방법?</p>
            </li>
            <li data-aos="fade-right" data-aos-delay="1000" data-aos-duration="1000">
                <span>5</span>
                <p>언제까지 힘들게 <i></i>일해야 하지?</p>
            </li>
        </ul>
        <div class="mainSysBtm">
            <h2 data-aos="fade-down" data-aos-delay="1100" data-aos-duration="500">전세계 최초 유일</h2>
            <h3 data-aos="fade-down" data-aos-delay="1200" data-aos-duration="700">예방뷰티 에너지테라피 <span>자동화 시스템</span></h3>
        </div>
    </div>
</div>
<!-- //mainSystem -->

<!-- mainSeven -->
<div class="mainSeven">
    <div class="contain">
        <h2 class="mainTit" data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">
            <p>The jogak Plus System</p>
            뷰티샵 매출증대 를 위해 <i></i>7가지가 준비되어 있어야 합니다
        </h2>
        <ul id="sevenMenu">
            <li class="on" data-aos="fade-down" data-aos-delay="400" data-aos-duration="1000">
                <img src="./assets/lasted/img/sevenIcon01.png" alt="">
                <h2>객단가</h2>
                <p>1회 20만원~80만원이상 체험하면 <i></i><strong>무조건 10회 티켓팅으로 <i></i>연결 되는 상담 기법 교육</strong></p>
            </li>
            <li data-aos="fade-down" data-aos-delay="550" data-aos-duration="400">
                <img src="./assets/lasted/img/sevenIcon02.png" alt="">
                <h2>회전율</h2>
                <p>일주일에 1회~2회 방문</p>
            </li>
            <li data-aos="fade-down" data-aos-delay="700" data-aos-duration="400">
                <img src="./assets/lasted/img/sevenIcon03.png" alt="">
                <h2>트렌드</h2>
                <p><strong>2023트렌드코리아</strong>에서 강조하는 <i></i>차별화 된 <strong>시스템 완벽 셋팅</strong></p>
            </li>
            <li data-aos="fade-down" data-aos-delay="850" data-aos-duration="400">
                <img src="./assets/lasted/img/sevenIcon04.png" alt="">
                <h2>고객만족</h2>
                <p>시술자도 고객님도 안전하고 <i></i><strong>건강해지는 최첨단 시스템</strong></p>
            </li>
            <li data-aos="fade-down" data-aos-delay="1000" data-aos-duration="400">
                <img src="./assets/lasted/img/sevenIcon05.png" alt="">
                <h2>효과</h2>
                <p>빠른 효과를 원하는 분에게 <i></i><strong>즉각적인 최고의 효과</strong></p>
            </li>
            <li data-aos="fade-down" data-aos-delay="1150" data-aos-duration="400">
                <img src="./assets/lasted/img/sevenIcon06.png" alt="">
                <h2>경영/마케팅</h2>
                <p>수 많은 <strong>성공사례</strong>를 배출한 <i></i><strong>뷰티샵 최적화 노하우</strong></p>
            </li>
            <li data-aos="fade-down" data-aos-delay="1300" data-aos-duration="400">
                <img src="./assets/lasted/img/sevenIcon07.png" alt="">
                <h2>차별화</h2>
                <p><strong>전세계 최초 유일 예방뷰티 <i></i>에너지테라피 자동화 시스템</strong><i></i>
                    누구나 원하는 조각같은 몸매<i></i>
                    힙업과 가슴 리프팅 자동화 시스템!
                </p>
            </li>
        </ul>
        <a href="/company/community/column" data-aos="fade-down" data-aos-delay="1400" data-aos-duration="400">뷰티샵 매출증대 칼럼 더보기</a>
    </div>
</div>
<!-- //mainSeven -->